import { FC, PropsWithChildren } from 'react';

import { useUserColorModeWithSync } from '../../hooks/use-user-color-mode-with-sync';

/**
 * Provider component that syncs user's color mode preference between
 * localStorage and the backend on app initialization.
 *
 * This should be placed near the root of the authenticated app tree
 * (after authentication providers but before most UI components).
 *
 * The sync logic handles:
 * - Preserving existing users' localStorage preferences to backend
 * - Restoring preferences from backend after logout/on new devices
 * - Setting default preference for new users
 * - Resolving conflicts (backend wins for cross-device consistency)
 *
 * This component renders its children immediately - the sync happens
 * in the background and doesn't block rendering.
 */
export const AppearancePreferencesSyncProvider: FC<PropsWithChildren> = ({ children }) => {
	// Just invoking the hook triggers the sync logic in its useEffect
	useUserColorModeWithSync();

	return <>{children}</>;
};
